module.exports = __webpack_public_path__ + "static/media/flames-of-desire.1921a2a7.md";